import { useEffect, useRef, useState } from "react";

export default function Dropdown({ label ="Filter By", icon: Icon, children, align = "left" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const close = () => setOpen(false);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((p) => !p)}
        className="flex-1 sm:flex-none border border-gray-300 rounded-md p-2 px-6 text-sm font-semibold text-gray-500 hover:bg-gray-100 flex items-center justify-center space-x-2 focus:outline-none"
      >
        {Icon && <Icon className="w-3 h-3" />}
        <span>{label}</span>
      </button>

      {open && (
        <div
          className={`absolute ${
            align === "right" ? "right-0" : "left-0"
          } mt-2 min-w-[10rem] bg-white  border-gray-200 rounded-md shadow-lg z-20`}
        >
         {typeof children === "function" ? children(close) : children}
        </div>
      )}
    </div>
  );
}